module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "website-dev"
  }, [_c('h1', [_vm._v("Website Development")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n\t\t\tWe provide customized web-based solutions tailored to the client’s specific business requirements using the latest technologies and industry trends.\n\t\t")]), _vm._v(" "), _c('h3', {
    staticClass: "collapse-link",
    on: {
      "click": function($event) {
        _vm.toggleCollapse('collapseA')
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapseA),
      expression: "!collapseA"
    }],
    staticClass: "glyphicon glyphicon-chevron-right"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapseA),
      expression: "collapseA"
    }],
    staticClass: "glyphicon glyphicon-chevron-down"
  }), _vm._v("\n\t\t\tWhy a Website is a worthwhile business investment\n\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapseA),
      expression: "collapseA"
    }],
    staticClass: "collapse-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "spacing10"
  }), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tLet us help you develop an efficient website solution for your business.\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "spacing30"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "collapse-link",
    on: {
      "click": function($event) {
        _vm.toggleCollapse('collapseB')
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapseB),
      expression: "!collapseB"
    }],
    staticClass: "glyphicon glyphicon-chevron-right"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapseB),
      expression: "collapseB"
    }],
    staticClass: "glyphicon glyphicon-chevron-down"
  }), _vm._v("\n\t\t\tWebsite Development Process\n\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapseB),
      expression: "collapseB"
    }],
    staticClass: "collapse-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "spacing10"
  }), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tWe deliver fast and effective website solutions.\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "spacing30"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "collapse-link",
    on: {
      "click": function($event) {
        _vm.toggleCollapse('collapseC')
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapseC),
      expression: "!collapseC"
    }],
    staticClass: "glyphicon glyphicon-chevron-right"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapseC),
      expression: "collapseC"
    }],
    staticClass: "glyphicon glyphicon-chevron-down"
  }), _vm._v("\n\t\t\tWhy our websites are the right solution for you\n\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapseC),
      expression: "collapseC"
    }],
    staticClass: "collapse-container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "spacing10"
  }), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tWe makes websites that are simple to update and customized for each client’s specific needs.\n\t\t\t")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "media-list icon-list"
  }, [_c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon glyphicon-globe"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Reach a wider audience regardless of geographical location.")])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-sunglasses"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Creates a professional look for your brand.")])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-repeat"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Saves you time answering the same questions over and over again.")])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-time"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Accessible around the clock 24/7.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "media-list icon-list"
  }, [_c('li', {
    staticClass: "media media-primary media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-primary-invert btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "customicon"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Information Gathering")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Purpose")]), _c('li', [_vm._v("Goals")]), _vm._v(" "), _c('li', [_vm._v("Target Audience")]), _vm._v(" "), _c('li', [_vm._v("Content")])])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-primary media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-primary-invert btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "customicon"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Planning")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Research")]), _vm._v(" "), _c('li', [_vm._v("Analyze")]), _vm._v(" "), _c('li', [_vm._v("Technologies")])])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-primary media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-primary-invert btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "customicon"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Design")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Look and Feel")]), _vm._v(" "), _c('li', [_vm._v("Responsive Design")])])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-primary media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-primary-invert btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "customicon"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Development")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Custom Web Development")]), _vm._v(" "), _c('li', [_vm._v("CMS (Content Management System)")]), _vm._v(" "), _c('li', [_vm._v("Documentation")])])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-primary media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-primary-invert btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "customicon"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Testing")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("General Testing")]), _vm._v(" "), _c('li', [_vm._v("Usability Testing")]), _vm._v(" "), _c('li', [_vm._v("Performance Profiling")])])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-primary media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-primary-invert btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "customicon"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Acceptance and Deployment")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Review and Approval")]), _vm._v(" "), _c('li', [_vm._v("Launch")])])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-primary media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-primary-invert btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "customicon"
  }, [_vm._v("7")])])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Maintenance")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Management")]), _vm._v(" "), _c('li', [_vm._v("SEO (Search Engine Optimization)")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "media-list icon-list"
  }, [_c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-user"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("User Friendly.")])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Easily Manageable.")])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-search"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Search Engine Friendly.")])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-phone"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Responsive with a multi-device friendly approach.")])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-heart"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Customized to the client’s specific needs.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c2b6b7cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/website-development/website-development.vue
// module id = 57
// module chunks = 1